import { render, staticRenderFns } from "./KitItem.vue?vue&type=template&id=d03a90f8"
import script from "./KitItem.vue?vue&type=script&lang=js"
export * from "./KitItem.vue?vue&type=script&lang=js"
import style0 from "./KitItem.vue?vue&type=style&index=0&id=d03a90f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports